import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 8px;

  &.background-black {
    background-color: black;
  }
`;

export const TextWrapper = styled(Flex)`
  z-index: ${Z_INDEX.onTop};
  width: 100%;
  height: 100%;

  &:hover {
    cursor: pointer;
  }
`;
